/**
 * SDK v2.1.3 event formatter
 * Uses FLAT gift format: {giftName, giftCount, value, totalValue, giftId}
 */

/**
 * Format normalized event for SDK v2.1.3 consumption
 * @param {object} normalizedEvent - Normalized event from parser
 * @returns {object} SDK-formatted event
 */
function formatForSDK(normalizedEvent) {
  const { type, platform, user, ...rest } = normalizedEvent;
  
  switch (type) {
    case 'comment':
    case 'chat':
      return {
        type: 'stream-chat',
        data: {
          user: formatUser(user, platform),
          message: rest.message || rest.text || '',
          messageId: rest.id || generateId(),
          platform,
          timestamp: rest.timestamp || Date.now()
        }
      };
      
    case 'gift':
      // SDK 2.1.3: FLAT format (fields directly on data)
      return {
        type: 'stream-gift',
        data: {
          user: formatUser(user, platform),
          giftId: rest.id || generateId(),
          giftName: rest.giftName || 'Gift',
          giftCount: rest.giftCount || 1,
          value: rest.value || 0,
          totalValue: rest.totalValue || (rest.value || 0) * (rest.giftCount || 1),
          platform,
          timestamp: rest.timestamp || Date.now()
        }
      };
      
    case 'like':
      return {
        type: 'stream-like',
        data: {
          user: formatUser(user, platform),
          count: rest.likeCount || rest.count || 1,
          platform,
          timestamp: rest.timestamp || Date.now()
        }
      };
      
    case 'join':
      return {
        type: 'stream-join',
        data: {
          user: formatUser(user, platform),
          memberCount: rest.memberCount || 0,
          action: rest.action || 1,
          platform,
          timestamp: rest.timestamp || Date.now()
        }
      };
      
    case 'follow':
      return {
        type: 'stream-follow',
        data: {
          user: formatUser(user, platform),
          platform,
          timestamp: rest.timestamp || Date.now()
        }
      };
      
    case 'share':
      return {
        type: 'stream-share',
        data: {
          user: formatUser(user, platform),
          platform,
          timestamp: rest.timestamp || Date.now()
        }
      };
      
    // SDK 2.1.3 doesn't have stats event
    case 'stats':
      return null; // Ignore stats for old SDK
      
    default:
      throw new Error(`Unknown event type: ${type}`);
  }
}

/**
 * Format user object for SDK
 * @param {object} user - Normalized user
 * @param {string} platform - Platform name
 * @returns {object} SDK user format
 */
function formatUser(user, platform) {
  return {
    id: `${platform}_${user.username}`,
    username: user.username,
    displayName: user.displayName || user.username,
    platform,
    imageUrl: user.imageUrl || null
  };
}

/**
 * Generate unique ID
 * @returns {string}
 */
function generateId() {
  return `${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
}

export { formatForSDK, formatUser };
